// material-ui
import { Fab } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AddIcon from "@material-ui/icons/Add";
// components
import CategoriesList from "components/CategoriesList";
import FormCategory from "components/FormCpfmCategory";
import Page from "components/Page";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class WrapperCategoryPage extends Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    loading: PropTypes.bool,

    //categories
    categories: PropTypes.array,
    getCpfmCategoryById: PropTypes.func,
    createCpfmCategory: PropTypes.func,
    deleteCpfmCategory: PropTypes.func,
    updateCpfmCategory: PropTypes.func,
    getCategories: PropTypes.func,

    // subCategories
    subCategories: PropTypes.array,
    getCategorySubCategories: PropTypes.func,
    createCategorySubCategory: PropTypes.func,
    deleteCategorySubCategory: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedCategory: undefined,
      formCategoryOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { categories, history, getCategories } = this.props;

    switch (index) {
      case 0:
        return (
          <CategoriesList
            getCategories={getCategories}
            history={history}
            categories={categories}
            onSelect={(selectedCategory) =>
              this.setState({
                selectedCategory,
                formCategoryOpen: true,
              })
            }
          />
        );
      default:
    }
  }

  render() {
    const {
      classes,
      history,
      loading,
      createCpfmCategory,
      deleteCpfmCategory,
      updateCpfmCategory,
      refresh,
      subCategories,
      getCategorySubCategories,
      createCategorySubCategory,
      deleteCategorySubCategory,
    } = this.props;

    const { index, selectedCategory, formCategoryOpen } = this.state;

    return (
      <Page
        loading={loading}
        helmet="Categories"
        fab={
          <Fab
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={() => this.setState({ formCategoryOpen: true })}
          >
            <AddIcon />
          </Fab>
        }
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push(`?index=${v}`);
            }}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="All"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormCategory
          subCategories={subCategories}
          getCategorySubCategories={getCategorySubCategories}
          createCategorySubCategory={createCategorySubCategory}
          deleteCategorySubCategory={deleteCategorySubCategory}
          open={formCategoryOpen}
          category={selectedCategory}
          close={() => {
            this.setState({
              formCategoryOpen: false,
            });
            setTimeout(
              () =>
                this.setState({
                  selectedCategory: undefined,
                }),
              200
            );
          }}
          createCpfmCategory={createCpfmCategory}
          deleteCpfmCategory={deleteCpfmCategory}
          updateCpfmCategory={updateCpfmCategory}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperCategoryPage);
